import { Capacitor } from "@capacitor/core"
import { Badge } from "@capawesome/capacitor-badge"
import { logger } from "../utils/logger"

/**
 * App-icon badge count. Native uses @capawesome/capacitor-badge; installed
 * PWAs use the Badging API. Both are best-effort — unsupported platforms
 * silently no-op.
 */
export async function setAppBadge(count: number): Promise<void> {
  try {
    if (Capacitor.isNativePlatform()) {
      const { isSupported } = await Badge.isSupported()
      if (!isSupported) return
      if (count > 0) {
        await Badge.set({ count })
      } else {
        await Badge.clear()
      }
      return
    }

    const nav = navigator as Navigator & {
      setAppBadge?: (count: number) => Promise<void>
      clearAppBadge?: () => Promise<void>
    }
    if (count > 0) {
      await nav.setAppBadge?.(count)
    } else {
      await nav.clearAppBadge?.()
    }
  } catch (error) {
    logger.warn("Failed to update app badge", { error })
  }
}
